import axios from 'axios';

const baseUrl = process.env.REACT_APP_API_URL;

const URL = `${baseUrl}/catalogo`;

export const getProductos = () => axios.get(URL);